import React, { Component } from 'react'
import { Route, Redirect, Switch } from 'react-router-dom'
import * as Containers from 'containers'
import { withRouter } from 'react-router-dom'

export class Routes extends Component{
  render = () =>
    <Switch>
      <Route exact path="/tokens/sign_in"              component={Containers.Token.SignIn}/>
      <Route exact path="/tokens/sign_up"              component={Containers.Token.SignUp}/>
      <Route exact path="/tokens/forgot"               component={Containers.Token.Forgot}/>
      <Route exact path="/tokens/reset"                component={Containers.Token.Reset}/>
      <Route exact path="/tokens/confirm"              component={Containers.Token.Confirm}/>
      <Route exact path="/tokens/resend_confirmation"  component={Containers.Token.ResendConfirmation}/>
      <Route exact path="/tokens/resend_invitation"    component={Containers.Token.ResendInvitation}/>
      <Route exact path="/tokens/accept_invitation"    component={Containers.Token.AcceptInvitation}/>
      <Route exact path="/kyc"                         component={Containers.Kyc} />
      <Route exact path="/under_construction"          component={Containers.UnderConstruction} />
      <Route exact path="/awaiting_confirmation"       component={Containers.AwaitingConfirmation} />
      <Route exact path="/confirmation_resent"         component={Containers.ConfirmationResent} />
      <Route exact path="/linkedin/callback"           component={Containers.LinkedInCallback} />
      <Route exact path="/error_occurred"              component={Containers.ErrorOccurred} />
      <Route component={() =>  <Redirect to={"/tokens/sign_in"}/>}/>
    </Switch>
}

export default withRouter(Routes)
